export const INDEX_START = 'INDEX_START';
export const INDEX_SUCCESS = 'INDEX_SUCCESS';
export const INDEX_FAILURE = 'INDEX_FAILURE';

export const NODE_RANDOMIZABLE_ACCOUNT_START = 'NODE_RANDOMIZABLE_ACCOUNT_START';
export const NODE_RANDOMIZABLE_ACCOUNT_SUCCESS = 'NODE_RANDOMIZABLE_ACCOUNT_SUCCESS';
export const NODE_RANDOMIZABLE_ACCOUNT_FAILURE = 'NODE_RANDOMIZABLE_ACCOUNT_FAILURE';

export const MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY_START = 'MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY_START';
export const MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY_SUCCESS = 'MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY_SUCCESS';
export const MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY_FAILURE = 'MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY_FAILURE';

export const RESERVABLE_FOR_WORK_START = 'RESERVABLE_FOR_WORK_START';
export const RESERVABLE_FOR_WORK_SUCCESS = 'RESERVABLE_FOR_WORK_SUCCESS';
export const RESERVABLE_FOR_WORK_FAILURE = 'RESERVABLE_FOR_WORK_FAILURE';

export const RESET_RANDOMIZE_PASSWORD_ERROR = 'RESET_RANDOMIZE_PASSWORD_ERROR';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
